export default __webpack_public_path__ + "static/bergerie-cb12c168bd7088baec90eb95aaf102bd.png";